import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  handleSubmit(e) {
    const errors = this.handleValidation(
      this.element.querySelectorAll(".c-form__field input")
    );

    if (Object.keys(errors).length > 0) return e.preventDefault();
  }

  // Use if field name isn't very user friendly e.g. "customer[password]""
  cleanError(fieldName) {
    const content = fieldName.split("[")[1];
    if (!content) return fieldName;

    return content.replace(/[\[\]']+/g, "").replace("_", " ");
  }

  handleValidation(fields) {
    let validation = {};

    fields.forEach((field) => {
      if (field.nextElementSibling) {
        field.nextElementSibling.classList.add("hidden");
      }

      if (field.required && field.value.length === 0) {
        const errors = validation[field.name]
          ? validation[field.name].errors
          : [];

        validation[field.name] = {
          field: field.name,
          errors: [
            ...errors,
            `Please provide a value for ${this.cleanError(field.name)}.`,
          ],
        };
      }

      if (field.dataset.match) {
        const targetField = [...fields].find(
          (_field) => _field.name === field.dataset.match
        );
        const errors = validation[field.name]
          ? validation[field.name].errors
          : [];

        if (targetField && targetField.value !== field.value) {
          validation[field.name] = {
            field: field.name,
            errors: [
              ...errors,
              `Please ensure ${this.cleanError(
                field.name
              )} matches ${this.cleanError(targetField.name)}.`,
            ],
          };
        }
      }

      if (field.type === "email" || field.name.includes("Email")) {
        const errors = validation[field.name]
          ? validation[field.name].errors
          : [];

        const validEmail = field.value
          .toLowerCase()
          .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          );

        if (!validEmail) {
          validation[field.name] = {
            field: field.name,
            errors: [
              ...errors,
              `Please ensure ${this.cleanError(
                targetField.name
              )} matches the correct format e.g. email@address.com`,
            ],
          };
        }
      }
    });
    
    // Display Errors
    Object.keys(validation).forEach((key) => {
      fields.forEach((field) => {
        if (field.name !== key) return;
        const errorElem = field.nextElementSibling;

        if (errorElem) {
          const { errors } = validation[key];

          if (errors.length === 0) {
            return errorElem.classList.add("hidden");
          }

          errorElem.classList.remove("hidden");
          errorElem.innerText = errors.join("\n");
        }
      });
    });

    return validation;
  }
}
